<template>
    <v-container fluid>
        <v-card class="mb-5 pa-2">
            <v-row>
                <v-col>
                    <v-form ref="form" @submit.prevent="save">
                        <sarala-table
                            :model="model"
                            ref="table"
                            @itemsFetched="itemsFetched"
                        >
                            <template #original_price="{ item }">
                                <i18n-n
                                    :value="Number(item.original_price)"
                                    format="currency"
                                ></i18n-n>
                            </template>
                            <template #partner_price="{ item }">
                                <v-currency-field
                                    v-bind="$t('money-config')"
                                    v-model="item.partner_price"
                                ></v-currency-field>
                            </template>
                            <template #whitelabel_price="{ item }">
                                <v-currency-field
                                    v-bind="$t('money-config')"
                                    v-model="item.whitelabel_price"
                                ></v-currency-field>
                            </template>

                            <template #partner="{ item }">
                                <v-radio-group v-model="item.partner" row>
                                    <v-radio
                                        :label="$t('form.status.active')"
                                        color="success"
                                        :value="true"
                                    ></v-radio>
                                    <v-radio
                                        :label="$t('form.status.disabled')"
                                        color="red"
                                        :value="false"
                                    ></v-radio>
                                </v-radio-group>
                            </template>
                            <template #whitelabel="{ item }">
                                <v-radio-group v-model="item.whitelabel" row>
                                    <v-radio
                                        :label="$t('form.status.active')"
                                        color="success"
                                        :value="true"
                                    ></v-radio>
                                    <v-radio
                                        :label="$t('form.status.disabled')"
                                        color="red"
                                        :value="false"
                                    ></v-radio>
                                </v-radio-group>
                            </template>
                            <template #action="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            icon
                                            tile
                                            v-on="on"
                                            :to="{
                                                name: 'modules.edit',
                                                params: { id: item.id },
                                            }"
                                        >
                                            <v-icon color="blue-grey" v-on="on"
                                                >mdi-pencil</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('form.actions.edit') }}</span>
                                </v-tooltip>
                            </template>
                        </sarala-table>

                        <FormActions
                            :loadingSave="loading"
                            :showBackButton="false"
                        >
                            <template #right-prepend>
                                <label class="subtitle-2 mr-4">
                                    <v-icon left>mdi-file-lock</v-icon>
                                    {{
                                        $t(
                                            'modules.form.labels.update-on-plans',
                                        )
                                    }}
                                </label>
                                <v-radio-group
                                    v-model="updateOnPlans"
                                    row
                                    class="mr-5"
                                >
                                    <v-card outlined class="mr-2 pa-5">
                                        <v-radio
                                            :label="$t('form.status.yes')"
                                            color="success"
                                            :value="true"
                                        ></v-radio>
                                    </v-card>
                                    <v-card outlined class="mr-2 pa-5">
                                        <v-radio
                                            :label="$t('form.status.no')"
                                            color="red"
                                            :value="false"
                                        ></v-radio>
                                    </v-card>
                                </v-radio-group>
                            </template>
                        </FormActions>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import FormActions from '@/components/utils/FormActions'
import SaralaTable from '@/shared/components/SaralaTable'
import Module from '@/models/plans/Module'
import _ from 'lodash'

export default {
    components: {
        FormActions,
        'sarala-table': SaralaTable,
    },

    data: () => {
        return {
            loading: false,
            items: null,
            updateOnPlans: false,
        }
    },

    computed: {
        model() {
            return new Module()
        },
    },

    methods: {
        itemsFetched(items) {
            this.items = items
        },

        async save() {
            this.loading = true

            let data = this.getDataUpdated()

            let res = null
            try {
                res = await this.$http.put('modules-batch', data)
            } finally {
                this.loading = false
            }

            if (!res) return

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('modules.form.feedback.success-batch'),
            )

            this.$refs.table.getItems()
        },

        getDataUpdated() {
            let data = {
                modules: [],
                update_on_plans: this.updateOnPlans,
            }

            _.each(this.items, module => {
                data.modules.push({
                    id: module.id,
                    partner_price: module.partner_price,
                    whitelabel_price: module.whitelabel_price,
                    partner: module.partner,
                    whitelabel: module.whitelabel,
                })
            })

            return data
        },
    },
}
</script>
